import { getJSON } from 'api/utils/requests';

export default {
  health: getJSON('/health'),
};
